/*
 * Velura v2 — Editorial enhancements
 * - Scroll progress bar
 * - Reveal-on-scroll (IntersectionObserver)
 * - Parallax for mosaic photos
 */
(function () {
  'use strict';

  // 1. Scroll progress bar
  function initProgressBar() {
    if (document.querySelector('.vv-progress')) return;
    const bar = document.createElement('div');
    bar.className = 'vv-progress';
    bar.innerHTML = '<div class="vv-progress__fill" data-progress></div>';
    document.body.appendChild(bar);
    const fill = bar.querySelector('[data-progress]');
    function update() {
      const scrolled = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? scrolled / max : 0;
      fill.style.transform = 'scaleX(' + ratio.toFixed(4) + ')';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // 2. Reveal on scroll (with IntersectionObserver)
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    const targets = document.querySelectorAll('.vv-reveal, .vv-reveal-clip');
    if (!targets.length) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach((t) => obs.observe(t));
  }

  // 3. Parallax for masonry mosaic photos
  function initParallax() {
    const items = document.querySelectorAll('[data-parallax]');
    if (!items.length || !('IntersectionObserver' in window)) return;
    const speeds = new Map();
    items.forEach((it) => speeds.set(it, parseFloat(it.dataset.parallax) || 0.15));
    function update() {
      items.forEach((it) => {
        const rect = it.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const offsetFromCenter = (window.innerHeight / 2) - center;
        const offset = offsetFromCenter * speeds.get(it);
        it.style.transform = 'translateY(' + offset.toFixed(1) + 'px)';
      });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Mark html as JS-ready BEFORE running other inits — this enables CSS gating.
    // Initial elements above-the-fold get .is-in immediately to avoid first-paint flicker.
    document.documentElement.classList.add('vv-js-ready');
    // Mark all reveals currently in viewport as already visible
    document.querySelectorAll('.vv-reveal, .vv-reveal-clip').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('is-in');
      }
    });
    initProgressBar();
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
